import React, { Component } from "react";
import "./back-arrow.css";
import { FaChevronLeft } from "react-icons/fa";

export default class BackArrow extends Component {
  render() {
    return (
      <div
        onClick={() => {
          if (window.location.href.indexOf("preview") > -1) {
            window.location.href = "/mystores";
          } else {
            window.location.href = "/templates";
          }
        }}
        className="back-arrow-container"
      >
        <FaChevronLeft />
      </div>
    );
  }
}
